import { Lock } from 'lucide-react';
import { formatRoleName } from '../../../../data/roleManagement/roleManagementData';

const AccessRestricted = ({ currentUserRole, message }) => {
  return (
    <div className="min-h-[400px] flex flex-col items-center justify-center bg-white rounded-2xl sm:rounded-3xl p-8 border border-slate-100 shadow-sm text-center">
      <div className="w-16 h-16 bg-rose-50 text-rose-500 rounded-2xl flex items-center justify-center mb-4">
        <Lock size={32} />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Restricted</h2>
      <p className="text-gray-500 max-w-md text-sm">
        {message || (
          <>
            Your role (<span className="font-bold text-gray-800">{formatRoleName(currentUserRole)}</span>) does not have permission to access Team & Role Management.
          </>
        )}
      </p>
    </div>
  );
};

export default AccessRestricted;
